import "./TradingAlertListComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {TradingAlert} from "../../models/alert/TradingAlert";
import {BehaviorSubject, Observable, ReplaySubject} from "rxjs";
import {TradingSystemsViewStore} from "../../../trading-systems/service/TradingSystemsViewStore";

export const AlertList = "tfTradingAlertList";

export function alertList(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/alert-list/TradingAlertListComponent.html`,
        transclude: true,
        bindings: {
            alerts: "<",
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: TradingAlertListComponentController
    };
}

export class TradingAlertListComponentController implements IOnInit, IOnDestroy {

    /* Input Binding */
    public set alerts(alerts: Array<TradingAlert> | null) {
        if (alerts == null) {
            this.alerts$.next([]);
        } else {
            this.alerts$.next(alerts);
        }
    }

    public readonly viewStore: TradingSystemsViewStore;

    public readonly alerts$ = new BehaviorSubject<Array<TradingAlert>>([]);
    public hasAlerts$: Observable<boolean>;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    public $onInit(): void {
        this.hasAlerts$ = this.alerts$
                              .takeUntil(this.destroyed$)
                              .map((alerts) => alerts.length > 0);
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
